import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import CommodityTradingMain from 'components/broker/commodity-trading'
import { ArticleJsonLd } from 'components/shared/schema/article'
import { Brokers_Linked_PageDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { pageUri } from 'shared/util'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const title = ({ broker }) => {
  return ` ${broker.name} Commodity Trading: charges, brokerage, details`
}

const description = ({ broker }) => {
  return `${broker.name} commodity trading brokerage, charges, details. How to do commodity trading in  ${broker.name}`
}

export default function Broker(props) {
  const router = useRouter()
  const { asPath } = router
  const { data: pageData } = props

  const {
    brokers,
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = pageData

  const broker = brokers.data[0].attributes
  const {
    articles: { data: articles },
  } = broker
  const pageTitle = title({ broker })
  const pageDescription = description({ broker })
  const country = {
    attributes: { name: broker.country.name },
  }
  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
      country={country}
    >
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Head>
      <ArticleJsonLd
        url={pageUri(asPath)}
        title={pageTitle}
        description={pageDescription}
      />
      <CommodityTradingMain broker={broker} articles={articles} />
    </ApplicationLayout>
  )
}

export async function getServerSideProps(context) {
  const apolloClient = initializeApollo()
  const {
    query: { slug },
  } = context

  const queryResults = await apolloClient.query({
    query: Brokers_Linked_PageDocument,
    variables: { slug, article_type: 'faq', page_url: 'commodity_trading' },
  })

  const { data } = queryResults

  return addApolloState(apolloClient, {
    props: { data },
  })
}
